import I18n from 'I18n';
import { Image } from 'foundations-components/transitional/components/Image';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SMALL_TILE_HEIGHT = '54px';
const TILE_HEIGHT = '70px';
const DataSyncTileIllustration = ({
  logo,
  illustration,
  imageSrc,
  imageAltTextMessageKey,
  isSmallSize = false
}) => {
  const tileHeight = isSmallSize ? SMALL_TILE_HEIGHT : TILE_HEIGHT;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [logo && /*#__PURE__*/_jsx(Logo, {
      "data-test-id": "data-sync-option-logo",
      margin: "0",
      name: logo,
      height: tileHeight
    }), illustration && /*#__PURE__*/_jsx(Illustration, {
      "data-test-id": "data-sync-option-illustation",
      margin: "0",
      name: illustration,
      height: tileHeight
    }), imageSrc && /*#__PURE__*/_jsx(Image, {
      "data-test-id": "data-sync-option-image",
      margin: "0",
      alt: imageAltTextMessageKey && I18n.text(imageAltTextMessageKey),
      src: imageSrc,
      blockSize: tileHeight,
      responsive: false
    })]
  });
};
export default DataSyncTileIllustration;